"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogInPage = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const PasswordInputControl_1 = require("../../../controls/PasswordInputControl");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("../../../constants/routes");
const sign_in_thunk_1 = require("../../../reducers/slices/user/thunks/sign_in_thunk");
const user_1 = require("../../../reducers/slices/user/user");
const facetecBypass_1 = require("../../../helpers/facetecBypass");
const LogInPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const code = searchParams.get("code");
    const returnUrl = searchParams.get("returnUrl");
    const { entryTheme } = (0, react_redux_1.useSelector)((state) => state.entryState);
    const { user, token, isLoading } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [emailMessage, setEmailMessage] = (0, react_1.useState)("");
    const [passwordMessage, setPasswordMessage] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if ((user === null || user === void 0 ? void 0 : user._id) && token) {
            // BYPASS CHECK: Staff with bypass permission or mobile users skip FaceTec
            if ((0, facetecBypass_1.shouldBypassFaceTec)()) {
                console.log("🔓 Login - Bypass active, navigating directly to console");
                const destination = returnUrl ? decodeURIComponent(returnUrl) : routes_1.CONSOLE_ROUTE;
                navigate(destination);
                return;
            }
            // Standard FaceTec flow: Authenticate at login
            // If user has FaceTec enrolled, redirect to authentication
            if (user === null || user === void 0 ? void 0 : user.facetecDBRef) {
                // Existing user with FaceTec - authenticate before console access
                const params = returnUrl ? `?return_to=custom&custom_url=${encodeURIComponent(returnUrl)}` : "?return_to=console";
                navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.FACETEC_ROUTE}${params}`);
            }
            else {
                // User without FaceTec - redirect to enrollment (REQUIRED)
                const params = returnUrl ? `?enroll=true&return_to=custom&custom_url=${encodeURIComponent(returnUrl)}` : "?enroll=true&return_to=console";
                navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.FACETEC_ROUTE}${params}`);
            }
        }
    }, [user]);
    (0, react_1.useEffect)(() => {
        if (code) {
            dispatch((0, sign_in_thunk_1.sign_in_thunk)({ code })).then((data) => {
                if (!data.payload) {
                    navigate(routes_1.WELCOME_ROUTE + routes_1.LOG_IN_ROUTE);
                }
            });
        }
    }, [code]);
    const onControlChanged = (name, value) => {
        dispatch((0, user_1.setUser)(Object.assign(Object.assign({}, user), { [name]: value })));
    };
    const validate = () => {
        let messageCount = 0;
        setEmailMessage("");
        setPasswordMessage("");
        if (!user.email) {
            messageCount++;
            setEmailMessage("Email is required.");
        }
        if (!user.password) {
            messageCount++;
            setPasswordMessage("Password is required.");
        }
        return messageCount ? false : true;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-y-4 h-full justify-center w-full lg:w-[700px] py-4 lg:py-0 px-4 lg:px-8" }, code ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { progressColor: "text-primary", size: "large" })) : (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "text-3xl font-bold" }, "Sign In"),
        react_1.default.createElement("div", { className: "w-10" },
            react_1.default.createElement(doshx_controls_web_1.DividerControl, { orientation: "horizontal", lineColor: "bg-black", addPadding: false })),
        react_1.default.createElement("div", { className: "text-sm font-light" }, "Sign in using your email address"),
        react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-4" },
            react_1.default.createElement("div", { className: "grid lg:flex gap-4 w-full" },
                react_1.default.createElement("div", { className: "w-full" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", type: "text", value: user.email || "", errorText: emailMessage, borderColor: "border-borders", onChange: (v) => {
                            onControlChanged("email", v);
                        } })),
                react_1.default.createElement("div", { className: "w-full" },
                    react_1.default.createElement(PasswordInputControl_1.PasswordInputControl, { label: "Password", borderColor: "border-borders", value: user.password || "", errorText: passwordMessage, onChange: (v) => {
                            onControlChanged("password", v);
                        } }))),
            react_1.default.createElement("div", { className: "flex flex-row justify-end items-center" },
                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Forgot password?", size: "small", onClick: () => {
                        navigate(`${routes_1.WELCOME_ROUTE}${routes_1.FORGOT_PASSWORD_ROUTE}`);
                    } })),
            react_1.default.createElement("div", { className: "w-[200px]" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Sign in", loading: isLoading, backgroundColor: "bg-secondary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        if (validate()) {
                            dispatch((0, sign_in_thunk_1.sign_in_thunk)({}));
                        }
                    }) }))),
        react_1.default.createElement("div", { className: "flex gap-1 pt-4 items-center justify-center" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Don't have an account?", textColor: "text-black" }),
            react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Create one now", textColor: entryTheme.config.colors.link.text, onClick: () => {
                    navigate(`${routes_1.WELCOME_ROUTE}${routes_1.SIGN_UP_ROUTE}`);
                } }))))));
};
exports.LogInPage = LogInPage;
